import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";
import ImageUploader from "Components/UI/ImageUploder";

const isStatusOption = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];

const DormitoryForm = () => {
  const {
    control,
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();
  return (
    <div className="form-row row">
      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="locationCode"
          type="text"
          placeholder="Location Code"
          className={`form-control ${errors.locationCode ? "is-invalid" : ""}`}
          label="Location Code"
          labelClassName="form-label"
          required={true}
          requiredMessage="Location Code is required"
          defaultValue=""
        />
      </div> */}

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="dormitoryName"
          type="text"
          placeholder="Dormitory Name"
          className={`form-control ${errors.dormitoryName ? "is-invalid" : ""}`}
          label="Dormitory Name"
          labelClassName="form-label"
          required={true}
          requiredMessage="Dormitory Name is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="inchargeName"
          type="text"
          placeholder="Incharge Name"
          className={`form-control ${errors.inchargeName ? "is-invalid" : ""}`}
          label="Incharge Name"
          labelClassName="form-label"
          required={true}
          requiredMessage="Incharge Name is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="inchargeNumber"
          type="text"
          placeholder="Incharge Contact Number"
          className={`form-control ${
            errors.inchargeNumber ? "is-invalid" : ""
          }`}
          label="Incharge Contact Number"
          labelClassName="form-label"
          required={false}
          requiredMessage="Incharge Number is required"
          defaultValue=""
          pattern="^\d{8}$"
            title="Enter exactly 8 digits of numbers"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="address"
          type="text"
          placeholder="Address"
          className={`form-control ${errors.address ? "is-invalid" : ""}`}
          label="Address"
          labelClassName="form-label"
          required={false}
          requiredMessage="Address is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="postalcode"
          type="text"
          placeholder="Postal Code"
          className={`form-control ${errors.postalcode ? "is-invalid" : ""}`}
          label="Postal Code"
          labelClassName="form-label"
          required={true}
          requiredMessage="Postal Code is required"
          defaultValue=""
          pattern="^\d{6}$"
            title="Enter exactly 6 digits of numbers"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="remarks"
          type="text"
          placeholder="Remarks"
          className={`form-control ${errors.remarks ? "is-invalid" : ""}`}
          label="Remarks"
          labelClassName="form-label"
          required={true}
          requiredMessage="Remarks is required"
          defaultValue=""
        />
      </div>


    

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="isActive"
          type="commonSelect"
          placeholder="Select Status"
          className={`form-control select ${
            errors.isActive ? "is-invalid" : ""
          }`}
          label="Status"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="Status is required"
          onChange={(selectedOption) => {
            setValue("isActive", selectedOption);
            trigger("isActive");
          }}
          defaultValue={watch("isActive")}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <label className="form-label">Attachment</label>
        <ImageUploader
          base64Value={watch("attachment")}
          setBase64Value={(value) => setValue("attachment", value)}
        />
      </div>

    </div>
  );
};

export default DormitoryForm;
